import React, { useState, useEffect, useMemo } from 'react';
import _ from 'lodash';
import moment from 'moment';
import 'moment/locale/fr';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var EventWrapper = function EventWrapper(props) {
  var event = props.event,
    parent = props.parent;
  moment.locale('fr');
  var startDate = moment(event.start);
  var endDate = moment(event.end);
  var startHour = _.toInteger(startDate.format('H'));
  var endHour = _.toInteger(endDate.format('H'));
  var _useState = useState('#3174ad'),
    backgroundColor = _useState[0];
  var _useState2 = useState(0),
    height = _useState2[0],
    setHeight = _useState2[1];
  var _useState3 = useState(0),
    marginTop = _useState3[0],
    setMarginTop = _useState3[1];
  useEffect(function () {
    if (!_.isNil(parent) && !_.isNil(parent.current) && !_.isNil(parent.current.clientHeight) && parent.current.clientHeight > 0) {
      var clientHeight = parent.current.clientHeight - 19.98; // 19.98 = .rbc-date-cell
      var heightHour = clientHeight / 12;
      var wrapperHeight = (endHour - startHour) * heightHour;
      if (wrapperHeight > clientHeight) {
        wrapperHeight = clientHeight;
      }
      var wrapperMargin = wrapperHeight !== clientHeight ? startHour / 2 * heightHour - wrapperHeight / 3 : 0;
      if (wrapperHeight <= 20) {
        wrapperHeight = 20;
      }
      if (wrapperMargin <= 0) {
        wrapperMargin = 0;
      }
      setMarginTop(wrapperMargin);
      setHeight(wrapperHeight);
    } else {
      setHeight(20);
    }
  }, [parent, endHour, startHour]);
  var wrapper = useMemo(function () {
    return /*#__PURE__*/_jsx("div", {
      // onClick={() => onSelect(event)}
      style: {
        zIndex: 10,
        marginTop: marginTop,
        height: height,
        backgroundColor: backgroundColor,
        borderRadius: 10,
        color: 'white'
      },
      children: /*#__PURE__*/_jsx("div", {
        style: {
          paddingRight: 10,
          paddingLeft: 10
        },
        children: /*#__PURE__*/_jsxs("div", {
          style: {
            flex: 1,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexDirection: 'row-reverse'
          },
          children: [/*#__PURE__*/_jsx("strong", {
            children: event.title
          }), startDate.format('HH:mm') + "-" + endDate.format('HH:mm')]
        })
      })
    });
  }, [marginTop, height, backgroundColor, event, startDate, endDate]);
  return wrapper;
};
EventWrapper.handledProps = ["event", "parent"];
EventWrapper.propTypes = {
  event: PropTypes.objectOf(PropTypes.string, PropTypes.number),
  parent: PropTypes.node
};
EventWrapper.defaultProps = {
  event: {
    start: '',
    end: ''
  },
  parent: null
};
export default EventWrapper;